import React from "react"
import challenges from "../images/Challenges0.png"
import health from "../images/Health0.png"
import styles from "../styles/ethosIcons.module.scss"
import wellness from "../images/Wellness0.png"

function EthosIcons(props) {
  return (
    <div className={styles.icons}>
      <div className={styles.icons_inner}>
        <div className={styles.icons_inner_health}>
          <img src={health} alt="health icon" />

          <h2>Health</h2>
          <p>
            My Power Up Fitness videos will guide you to your healthiest you,
            using your ethos, of course!
          </p>
        </div>
        <div className={styles.icons_inner_wellness}>
          <img src={wellness} alt="wellness icon" />
          <h2>Wellness</h2>
          <p>
            My Power Down Thought Coaching videos will prepare you to take on
            life’s daily stresses.
          </p>
        </div>
        <div className={styles.icons_inner_challenges}>
          <img src={challenges} alt="challenges icon" />

          <h2>Challenges</h2>
          <p>
            My specially curated challenges are ways for us to work together
            through Fitness and Thought Coaching, using your ethos manifest as
            the foundation.
          </p>
        </div>
      </div>
    </div>
  )
}

export default EthosIcons
